<template>
  <div id="app" :class="{is_fixed: isFixed}">
    <router-view  to="/"></router-view>

    <!-- Loading -->
    <template v-if="this.isLoading">
      <loading />
    </template>
  </div>
</template>

<script>
import Loading from './components/Modal/Loading'
import { mapGetters } from 'vuex'
import '@/styles/color.css'

export default {
  name: 'App',
  components: { Loading },
  computed: {
    ...mapGetters({
      isLoading: 'Loading/isLoading',
      isFixed: 'Modal/isFixed'
    })
  }
}
</script>

<style>

/*[CAUTION] Avv.vueの設定は全体のStyle定義のみ記述する */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

html,body {
  height: 100%;
  min-height: 100%;
  max-width: 100%;
  margin: 0;
  padding: 0;
  background-color: var(--background-color);
}

#app {
  font-family: -apple-system, BlinkMacSystemFont, "ヒラギノ角ゴ ProN W3", Hiragino Kaku Gothic ProN, Roboto, Arial, sans-serif;;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  height: 100%;
}

/* モーダル表示のタイミングでスクロールを固定するため */
.is_fixed {
  position: fixed;
}

</style>
